import m from "../../geodata/es2015/bhutanLow";
window.am4geodata_bhutanLow = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/bhutanLow.js
// module id = null
// module chunks = 